export default __webpack_public_path__ + "static/media/i198jk.39c62a87.webp";